import { SvgIcon, SxProps } from "@mui/material";
import IconSvg from "jsx:../../../Images/Icons/FontAwesome/solid/left.svg";

export function LeftIcon(props: SxProps) {
    return <SvgIcon component={IconSvg} inheritViewBox sx={props} />;
}
